module.exports = {
  "name": "@emotion/core",
  "version": "10.0.17",
  "main": "dist/core.cjs.js",
  "module": "dist/core.esm.js",
  "browser": {
    "./dist/core.cjs.js": "./dist/core.browser.cjs.js",
    "./dist/core.esm.js": "./dist/core.browser.esm.js"
  },
  "types": "types/index.d.ts",
  "files": [
    "src",
    "dist",
    "types"
  ],
  "author": "mitchellhamilton <mitchell@mitchellhamilton.me>",
  "license": "MIT",
  "scripts": {
    "test:typescript": "dtslint types"
  },
  "dependencies": {
    "@babel/runtime": "^7.5.5",
    "@emotion/cache": "^10.0.17",
    "@emotion/css": "^10.0.14",
    "@emotion/serialize": "^0.11.10",
    "@emotion/sheet": "0.9.3",
    "@emotion/utils": "0.11.2"
  },
  "peerDependencies": {
    "react": ">=16.3.0"
  },
  "devDependencies": {
    "@emotion/styled": "^10.0.17",
    "@types/react": "^16.8.20",
    "dtslint": "^0.3.0",
    "emotion": "^10.0.17",
    "emotion-server": "^10.0.17",
    "emotion-theming": "^10.0.17",
    "html-tag-names": "^1.1.2",
    "svg-tag-names": "^1.1.1"
  },
  "repository": "https://github.com/emotion-js/emotion/tree/master/packages/core",
  "publishConfig": {
    "access": "public"
  },
  "umd:main": "dist/core.umd.min.js",
  "preconstruct": {
    "umdName": "emotionCore"
  }
};